import { Component, EventEmitter, Input, Output, computed } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Dialog, DialogModule } from "@angular/cdk/dialog";
import { JobAssetDto } from "../../../../../domains/media/models/JobAssetDto";
import { ReopenConfirmationModalComponent, ReopenConfirmationData } from "../reopen-confirmation-modal/reopen-confirmation-modal.component";

export enum CompletedIssueExpansionState {
  Collapsed = "collapsed",
  Expanded = "expanded",
  FullyExpanded = "fully-expanded"
}

export interface CompletedIssue {
  id?: number;
  identifier: string;
  text: string;
  isComplete: boolean;
  jobId: number;
  media?: JobAssetDto[];
  areaName?: string;
  expansionState: CompletedIssueExpansionState;
  isSelfAssigned?: boolean;
  jobIssueVendors?: Array<{ externalVendorId: number; deleted?: boolean }>;
  completedAt?: Date;
}


@Component({
  selector: "app-completed-item",
  standalone: true,
  imports: [CommonModule, DialogModule],
  templateUrl: "./issue-item.component.html",
  styleUrls: ["./issue-item.component.scss"]
})
export class CompletedItemComponent {
  @Input() issue!: CompletedIssue;
  @Output() stateChange = new EventEmitter<CompletedIssueExpansionState>();
  @Output() reopen = new EventEmitter<CompletedIssue>();
  @Input() vendors: Array<{ id: number; name: string }> = [];

  // Computed signal for media URLs
  mediaUrls = computed(() => {
    if (!this.issue.media || this.issue.media.length === 0) {
      return [];
    }

    return this.issue.media.map(media => media.azureBlobUri || null).filter(url => url !== null);
  });

  constructor(private dialog: Dialog) { }

  toggleExpansion(): void {
    const next = this.issue.expansionState === CompletedIssueExpansionState.FullyExpanded
      ? CompletedIssueExpansionState.Collapsed
      : CompletedIssueExpansionState.FullyExpanded;
    this.stateChange.emit(next);
  }

  async onReopen(): Promise<void> {
    const dialogData: ReopenConfirmationData = {
      areaName: this.issue.areaName,
      issueText: this.issue.text
    };

    const dialogRef = this.dialog.open(ReopenConfirmationModalComponent, {
      data: dialogData,
      width: "50%",
      maxWidth: "600px",
      minWidth: "350px"
    });

    const result = await dialogRef.closed.toPromise();

    if (result === true) {
      this.reopen.emit(this.issue);
    }
  }

  isSelfAssigned(): boolean {
    return !!this.issue.isSelfAssigned;
  }

  getVendorNameById(vendorId: number): string {
    const vendor = this.vendors.find(v => v.id === vendorId);
    return vendor ? vendor.name : String(vendorId);
  }
}


